function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { FormFieldBuilder } from "./FormFieldBuilder";
import { FileUploader } from "./FileUploader";
import { CustomFormApiService } from "../Services/CustomFormApiService";
import { OAuthService } from "../Services/OAuthService";
import { I18N } from "../Shared/I18n";
var _customFormInputPrefix = ""; // Gets set in RenderCustomForm function

export var CustomFormBuilder = /*#__PURE__*/function () {
  function CustomFormBuilder() {
    _classCallCheck(this, CustomFormBuilder);
  }

  _createClass(CustomFormBuilder, null, [{
    key: "getTranslations",
    value: function () {
      var _getTranslations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._i18n) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return new I18N("mpp-custom-form")["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 3:
                i18n = _context.sent;
                this._i18n = i18n;

              case 5:
                return _context.abrupt("return", this._i18n);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTranslations() {
        return _getTranslations.apply(this, arguments);
      }

      return getTranslations;
    }()
    /**
     * @summary Will render a custom form.
     * @param {string} customFormGuid The custom forms Guid identifier
     * @param {Element} customFormFieldsElement The html element that will house the custom form elements
     * @param {Element} customFormRootElement The root html form element which contains the customFormFieldsElement
     */

  }, {
    key: "RenderCustomForm",
    value: function () {
      var _RenderCustomForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(customFormGuid, customFormFieldsElement, customFormRootElement, skipFormInstructions, isUserAuthenticated) {
        var customFormService, _yield$Promise$all, _yield$Promise$all2, customFormData, customFormConfig, customForm;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getTranslations();

              case 2:
                customFormFieldsElement.innerHTML = "";

                if (!customFormGuid) {
                  _context2.next = 15;
                  break;
                }

                customFormService = new CustomFormApiService();
                _context2.next = 7;
                return Promise.all([customFormService.GetFormFields(customFormGuid), customFormService.GetConfigurations(), customFormService.GetForm(customFormGuid)]);

              case 7:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                customFormData = _yield$Promise$all2[0];
                customFormConfig = _yield$Promise$all2[1];
                customForm = _yield$Promise$all2[2];
                _customFormInputPrefix = customFormConfig.customFormInputPrefix;
                skipFormInstructions !== true && this.DrawFormInstructions(customFormFieldsElement, customFormData);

                if (customForm.formData.Force_Login && !isUserAuthenticated) {
                  this.DrawLoginRequest(customFormFieldsElement);
                } else {
                  CustomFormBuilder.DrawForm(customFormFieldsElement, customFormData, customFormRootElement);
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function RenderCustomForm(_x, _x2, _x3, _x4, _x5) {
        return _RenderCustomForm.apply(this, arguments);
      }

      return RenderCustomForm;
    }()
  }, {
    key: "DrawLoginRequest",
    value: function () {
      var _DrawLoginRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(customFormFieldsElement) {
        var errorMessageContainer, errorIcon, errorMessage, loginButtonContainer, loginButton;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getTranslations();

              case 2:
                errorMessageContainer = document.createElement("div");
                errorMessageContainer.classList.add("mppw-alert");
                errorMessageContainer.classList.add("mppw-alert__warning");
                errorIcon = document.createElement("div");
                errorIcon.classList.add("mppw-alert__icon");
                errorMessageContainer.appendChild(errorIcon);
                errorMessage = document.createElement("span");
                errorMessage.classList.add("mppw-alert__text");
                errorMessage.innerText = this._i18n.customFormPleaseLoginMessage;
                errorMessageContainer.appendChild(errorMessage);
                loginButtonContainer = document.createElement("div");
                loginButtonContainer.style.display = "flex";
                loginButtonContainer.style.justifyContent = "center";
                loginButtonContainer.style.marginBottom = "20px";
                loginButton = document.createElement("input");
                loginButton.setAttribute("type", "button");
                loginButton.className = "mppw-btn primary";
                loginButton.value = "Login";
                loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });
                customFormFieldsElement.appendChild(errorMessageContainer);
                loginButtonContainer.appendChild(loginButton);
                customFormFieldsElement.appendChild(loginButtonContainer);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function DrawLoginRequest(_x6) {
        return _DrawLoginRequest.apply(this, arguments);
      }

      return DrawLoginRequest;
    }()
  }, {
    key: "DrawFormInstructions",
    value: function DrawFormInstructions(formContainer, data) {
      // Display custom forms instructions label
      if (!!data && !!data.instructions) {
        var formInstructions = document.createElement("h3");
        formInstructions.innerHTML = data.instructions;
        formContainer.appendChild(formInstructions);
      }
    }
  }, {
    key: "DrawForm",
    value: function DrawForm(formContainer, data, root) {
      var _this2 = this;

      var formFieldBuilder = new FormFieldBuilder(); // Add hidden inputs

      if (!!data && data.formFields.length > 0) {
        // Add custom form id, this will be needed later when saving the form
        var formIdInputContainer = document.createElement("div");
        var formIdElement = formFieldBuilder.BuildHiddenInput(_customFormInputPrefix + "formid", data.formFields[0].Form_ID);
        formIdInputContainer.innerHTML = formIdElement;
        formContainer.appendChild(formIdInputContainer);
      }

      for (var r = 0; r < data.formFields.length; r++) {
        var $formRow = document.createElement("div");
        var $formControl = document.createElement("div");

        if (!data.formFields[r]["Is_Hidden"]) {
          // Create each field type
          $formControl.innerHTML = this.BuildFormControl(data.formFields[r], formContainer, root);
          $formRow.appendChild($formControl);
          formContainer.appendChild($formRow); // Setup depends on fields

          data.uniqueParentFields.forEach(function (fieldId) {
            if (data.formFields[r].Form_Field_ID === fieldId) {
              // Bind event listener to these field id's
              _this2.BindParentFormFieldListener(data.formFields[r], root, data.customFieldsTree);
            }
          });
        }
      }
    }
  }, {
    key: "BindParentFormFieldListener",
    value: function BindParentFormFieldListener(formField, root, customFieldsTree) {
      var self = this; // The types of fields

      var FieldTypes = {
        "VerticalRadioButtons": 4,
        "HorizontalRadioButtons": 7
      }; // Only allow radio buttons

      if (formField.Field_Type_ID === FieldTypes.HorizontalRadioButtons || formField.Field_Type_ID === FieldTypes.VerticalRadioButtons) {
        root.querySelector('#formFields').addEventListener('change', function (event) {
          if (event.target.id == formField.Form_Field_ID.toString()) {
            var dependsOnSelectedId = event.target.id;
            var dependsOnSelectedValue = event.target.value; // Show all elements with dependsOnSelectedId and dependsOnSelectedValue

            self.ShowHideDependsOnElements(dependsOnSelectedId, dependsOnSelectedValue, root, customFieldsTree);
          }
        });
      } else {
        return;
      }
    } // When initially loading the form disable all depends on field inputs

  }, {
    key: "DisableAllDependsOnInputs",
    value: function DisableAllDependsOnInputs(root) {
      // Get all dependent fields
      var dependsOnFields = root.querySelectorAll('[data-depends-on-value]');

      for (var i = 0; i < dependsOnFields.length; i++) {
        var dependsOnFieldValue = dependsOnFields[i].getAttribute("data-depends-on-value"); // Only hide if element has a depends on value

        if (!!dependsOnFieldValue) {
          // Get all inputs for the given div
          var inputElements = dependsOnFields[i].getElementsByTagName("input");
          var selectElements = dependsOnFields[i].getElementsByTagName("select");
          var textareaElements = dependsOnFields[i].getElementsByTagName("textarea"); // Hide fields

          dependsOnFields[i].style.display = 'none'; // Add disabled to prevent form validation issues on hidden inputs

          var _iterator = _createForOfIteratorHelper(inputElements),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var el = _step.value;
              el.setAttribute("disabled", "disabled");
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var _iterator2 = _createForOfIteratorHelper(selectElements),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _el = _step2.value;

              _el.setAttribute("disabled", "disabled");
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var _iterator3 = _createForOfIteratorHelper(textareaElements),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _el2 = _step3.value;

              _el2.setAttribute("disabled", "disabled");
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
    }
  }, {
    key: "FindNodeById",
    value: function FindNodeById(node, id) {
      if (node.nodeId == id) {
        return node;
      } else {
        var _iterator4 = _createForOfIteratorHelper(node.children),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var child = _step4.value;
            var result = this.FindNodeById(child, id);

            if (result != null) {
              return result;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return null;
    }
  }, {
    key: "HideElement",
    value: function HideElement(node, root) {
      var formRoot = root; // Select all elements based on parentId

      var hideField = formRoot.querySelector("[data-id='".concat(node.nodeId, "']"));

      if (hideField !== null && hideField !== undefined) {
        // Get all inputs for the given element
        var inputElements = hideField.getElementsByTagName("input");
        var selectElements = hideField.getElementsByTagName("select");
        var textareaElements = hideField.getElementsByTagName("textarea"); // Hide fields

        hideField.style.display = 'none'; // If the form is validated, need to remove any validation errors when switching between depends on fields
        // Otherwise this causes some weird UI display issues

        if (hideField.classList.contains('mppw-form-field--is-invalid')) {
          hideField.classList.remove('mppw-form-field--is-invalid');

          if (hideField.nextSibling) {
            if (hideField.nextSibling.classList.contains('mppw-form-field__message_container')) {
              hideField.nextSibling.remove();
            }
          }
        } // Add disabled to prevent form validation issues on hidden inputs


        var _iterator5 = _createForOfIteratorHelper(inputElements),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var el = _step5.value;

            if (el.type === 'radio') {
              // Clear any previous radio checked options
              el.checked = 0;
            }

            el.setAttribute("disabled", true);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        var _iterator6 = _createForOfIteratorHelper(selectElements),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _el3 = _step6.value;

            _el3.setAttribute("disabled", true);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _iterator7 = _createForOfIteratorHelper(textareaElements),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _el4 = _step7.value;

            _el4.setAttribute("disabled", true);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    } // Flattens a tree

  }, {
    key: "FlattenTree",
    value: function FlattenTree(root) {
      var stack = [],
          array = [],
          hashMap = {},
          nodeRoot = root;
      stack.push(nodeRoot);

      while (stack.length !== 0) {
        var node = stack.pop();

        if (node) {
          if (node.children.length <= 0) {
            if (!hashMap[node.nodeId]) {
              hashMap[node.nodeId] = true;
              array.push(node);
            }
          } else {
            if (!hashMap[node.nodeId]) {
              hashMap[node.nodeId] = true;

              var tempNode = _objectSpread({}, node);

              tempNode.children = [];
              array.push(tempNode);
            }

            for (var i = node.children.length - 1; i >= 0; i--) {
              stack.push(node.children[i]);
            }
          }
        }
      }

      return array;
    }
  }, {
    key: "HideAllElements",
    value: function HideAllElements(elementsArray, root) {
      var formRoot = root;

      var _iterator8 = _createForOfIteratorHelper(elementsArray),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var el = _step8.value;
          this.HideElement(el, formRoot);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    } // Shows or hides inputs based on depends on value

  }, {
    key: "ShowHideDependsOnElements",
    value: function ShowHideDependsOnElements(dependsOnId, dependsOnValue, root, customFieldsTree) {
      var formRoot = root; // Try to find node at top-level array location based on dependsonid

      var node = customFieldsTree.find(function (n) {
        return n.nodeId === dependsOnId;
      }); // If the node was not found at the top-level location
      // all levels of children need to be searched

      if (node === undefined || node === null) {
        for (var i = 0; i < customFieldsTree.length; i++) {
          node = this.FindNodeById(customFieldsTree[i], dependsOnId);

          if (node !== undefined && node !== null) {
            break;
          }
        }
      } // Set the nodesToHide initially to the node found above


      var nodesToHide = node; // If this node has children then set it to those children

      if (node) {
        if (node.children.length > 0) {
          nodesToHide = node.children.filter(function (n) {
            return n.value != dependsOnValue;
          });
        }

        var _iterator9 = _createForOfIteratorHelper(nodesToHide),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _node = _step9.value;
            // Create a flattened array of all elements at this nodes level
            var flattenedArray = this.FlattenTree(_node); // Take the flattened array and hide all elements within it

            this.HideAllElements(flattenedArray, formRoot);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      } // Get all dependent fields to show


      var showFields = formRoot.querySelectorAll("[data-depends-on='".concat(dependsOnId, "']"));

      for (var i = 0; i < showFields.length; i++) {
        var dataAttrValue = showFields[i].getAttribute("data-depends-on-value"); // Get all inputs for the given div

        var inputElements = showFields[i].getElementsByTagName("input");
        var textareaElements = showFields[i].getElementsByTagName("textarea");
        var selectElements = showFields[i].getElementsByTagName("select");

        if (dataAttrValue === dependsOnValue) {
          // Show fields
          showFields[i].style.display = 'block'; // Remove the disabled attribute on elements

          var _iterator10 = _createForOfIteratorHelper(inputElements),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var el = _step10.value;
              el.removeAttribute("disabled");
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }

          var _iterator11 = _createForOfIteratorHelper(selectElements),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _el5 = _step11.value;

              _el5.removeAttribute("disabled");
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }

          var _iterator12 = _createForOfIteratorHelper(textareaElements),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _el6 = _step12.value;

              _el6.removeAttribute("disabled");
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
        }
      }
    }
  }, {
    key: "BuildFormControl",
    value: function BuildFormControl(fieldData, formContainer, root) {
      var formFieldBuilder = new FormFieldBuilder(); // The types of fields

      var FieldTypes = {
        "TextBox": 1,
        "Textarea": 2,
        "Date": 3,
        "VerticalRadioButtons": 4,
        "DropdownList": 5,
        "Instructions": 6,
        "HorizontalRadioButtons": 7,
        "Checkbox": 8,
        "FileUpload": 9
      }; // Assign passed in fieldData

      var Form_Field_ID = fieldData.Form_Field_ID,
          Field_Label = fieldData.Field_Label,
          Alternate_Label = fieldData.Alternate_Label,
          Field_Type_ID = fieldData.Field_Type_ID,
          Required = fieldData.Required,
          Field_Order = fieldData.Field_Order,
          Field_Values = fieldData.Field_Values,
          Depends_On = fieldData.Depends_On,
          Depends_On_Value = fieldData.Depends_On_Value;
      var Label = !!Alternate_Label ? Alternate_Label : Field_Label;
      var controlHtml = "";

      switch (fieldData["Field_Type_ID"]) {
        case FieldTypes.TextBox:
          if (!!Depends_On && !!Depends_On_Value) {
            // Set field to be initially hidden/disabled.
            // Once the user sets a value for the parent depends on field will they be shown
            controlHtml = formFieldBuilder.BuildCustomTextInput(Form_Field_ID, Field_Label, Required, '', '', true, Depends_On, Depends_On_Value, 250, true, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomTextInput(Form_Field_ID, Field_Label, Required, '', '', false, '', '', 250, true, Alternate_Label);
          }

          break;

        case FieldTypes.Textarea:
          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomTextarea(Form_Field_ID, Field_Label, Required, true, 30000, true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomTextarea(Form_Field_ID, Field_Label, Required, true, 30000, null, '', '', Alternate_Label);
          }

          break;

        case FieldTypes.Date:
          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomDateInput(Form_Field_ID, Field_Label, Required, '', '', '', '', true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomDateInput(Form_Field_ID, Field_Label, Required, '', '', '', '', null, '', '', Alternate_Label);
          }

          break;

        case FieldTypes.VerticalRadioButtons:
          var vRadioOptions = Field_Values.split(/\r?\n/);

          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomVerticalRadio(Form_Field_ID, Field_Label, Required, vRadioOptions, true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomVerticalRadio(Form_Field_ID, Field_Label, Required, vRadioOptions, null, '', '', Alternate_Label);
          }

          break;

        case FieldTypes.DropdownList:
          var selectOptions = Field_Values.split(/\r?\n/);

          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomSelect(Form_Field_ID, Field_Label, Required, selectOptions, true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomSelect(Form_Field_ID, Field_Label, Required, selectOptions, null, '', '', Alternate_Label);
          }

          break;

        case FieldTypes.Instructions:
          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomParagraph(Label, true, Depends_On, Depends_On_Value, Form_Field_ID);
          } else {
            controlHtml = formFieldBuilder.BuildCustomParagraph(Label);
          }

          break;

        case FieldTypes.HorizontalRadioButtons:
          var hRadioOptions = Field_Values.split(/\r?\n/);

          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomHorizontalRadio(Form_Field_ID, Field_Label, Required, hRadioOptions, true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomHorizontalRadio(Form_Field_ID, Field_Label, Required, hRadioOptions, null, '', '', Alternate_Label);
          }

          break;

        case FieldTypes.Checkbox:
          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomCheckbox(Form_Field_ID, Label, Required, true, Depends_On, Depends_On_Value);
          } else {
            controlHtml = formFieldBuilder.BuildCustomCheckbox(Form_Field_ID, Label, Required);
          }

          break;

        case FieldTypes.FileUpload:
          var fileUploadHtml = '';

          if (!!Depends_On && !!Depends_On_Value) {
            fileUploadHtml = formFieldBuilder.BuildCustomFileUploader(Form_Field_ID, Field_Label, Required, '', true, Depends_On, Depends_On_Value, Alternate_Label);
          } else {
            fileUploadHtml = formFieldBuilder.BuildCustomFileUploader(Form_Field_ID, Field_Label, Required, '', null, '', '', Alternate_Label);
          }

          var fileUploader = new FileUploader();
          fileUploader.InitializeFileUploader(Form_Field_ID, formContainer, fileUploadHtml, root, this._i18n.invalidFileTypeMessage, this._i18n.invalidFileSizeMessage, this._i18n.selectDifferentFileMessage);
          break;

        default:
          if (!!Depends_On && !!Depends_On_Value) {
            controlHtml = formFieldBuilder.BuildCustomTextInput(Form_Field_ID, Field_Label, Required, '', '', true, Depends_On, Depends_On_Value, 250, true, Alternate_Label);
          } else {
            controlHtml = formFieldBuilder.BuildCustomTextInput(Form_Field_ID, Field_Label, Required, '', '', false, '', '', 250, true, Alternate_Label);
          }

          break;
      }

      return controlHtml;
    } // Draw the contact form based on the custom form template html file

  }, {
    key: "DrawContactForm",
    value: function DrawContactForm(i18n, formContainer) {
      var contactFormHtml =  `<div id="contactDetailsDiv"><div class="mppw-row"><div class="mppw-col"><h3>${i18n.contactLabel}</h3></div></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="firstName" name="FirstName" class="mppw-form-field__control" required="" data-required-message="First Name is required"> <label class="mppw-form-field__label" for="firstName">${i18n.firstNameLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="text" id="lastName" name="LastName" class="mppw-form-field__control" required="" data-required-message="Last Name is required"> <label class="mppw-form-field__label" for="lastName">${i18n.lastNameLabel}*:</label></div></div></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-form-field"><input type="email" id="emailAddress" name="EmailAddress" class="mppw-form-field__control" required="" data-require-if-blank="MobilePhoneNumber" data-required-message="${i18n.phoneOrEmailRequiredLabel}"> <label class="mppw-form-field__label" for="emailAddress">${i18n.emailAddressLabel}*:</label></div></div><div class="mppw-col"><div class="mppw-form-field"><input type="tel" id="mobilePhone" name="MobilePhoneNumber" class="mppw-form-field__control" required="" data-require-if-blank="EmailAddress" data-required-message="${i18n.phoneOrEmailRequiredLabel}"> <label class="mppw-form-field__label" for="mobilePhone">${i18n.mobilePhoneLabel}*:</label></div></div></div></div>` ;
      var $formRow = document.createElement("div");
      var $formControl = document.createElement("div");
      $formControl.innerHTML = contactFormHtml;
      $formRow.appendChild($formControl);
      formContainer.appendChild($formRow);
    } // Draw the address form based on the custom form template html file

  }, {
    key: "DrawAddressForm",
    value: function DrawAddressForm(i18n, formContainer, countryDropdownData) {
      this._formFieldBuilder = new FormFieldBuilder();
      var addressFormHtml =  `<div class="mppw-row"><div class="mppw-col"><h3>${i18n.addressLabel}</h3></div></div><div class="mppw-row"><div class="mppw-col">${this._formFieldBuilder.BuildCustomFormSelect("Country", i18n.countryLabel, true, countryDropdownData)}</div></div><div class="mppw-form-field"><input type="text" id="addressLine1" name="AddressLine1" class="mppw-form-field__control" required="" data-required-message="Address Line 1 is required"> <label class="mppw-form-field__label" for="addressLine1">${i18n.addressLineLabel} 1*:</label></div><div class="mppw-form-field"><input type="text" id="addressLine2" name="AddressLine2" class="mppw-form-field__control"> <label class="mppw-form-field__label" for="addressLine2">${i18n.addressLineLabel} 2:</label></div><div class="mppw-row"><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="city" name="City" class="mppw-form-field__control" required="" data-required-message="City is required"> <label class="mppw-form-field__label" for="addressLine1">${i18n.cityLabel}*:</label></div></div><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="stateRegion" name="StateRegion" class="mppw-form-field__control" required="" data-required-message="State is required"> <label class="mppw-form-field__label" for="addressLine1">${i18n.stateRegionLabel}*:</label></div></div><div class="mpp-customform-col-4"><div class="mppw-form-field"><input type="text" id="postalCode" name="PostalCode" class="mppw-form-field__control" required="" data-required-message="Postal Code is required"> <label class="mppw-form-field__label" for="addressLine1">${i18n.postalCodeLabel}*:</label></div></div></div>` ;
      var $formRow = document.createElement("div");
      var $formControl = document.createElement("div");
      $formControl.innerHTML = addressFormHtml;
      $formRow.appendChild($formControl);
      formContainer.appendChild($formRow);
    }
  }, {
    key: "BuildHtml",
    value: function BuildHtml(elementType, options, text, click) {
      var el = document.createElement(elementType);

      if (!!options) {
        options.forEach(function (opt) {
          if (opt[0] === "class") {
            el.classList.add(opt[1]);
            return;
          }

          el.setAttribute(opt[0], opt[1]);
        });
      }

      if (!!text) {
        el.appendChild(document.createTextNode(text));
      }

      if (!!click) {
        el.addEventListener("click", click);
      }

      return el;
    }
  }]);

  return CustomFormBuilder;
}();